import { ccwpApi } from "@/services";

export const ClaimSubmissionsApi = ccwpApi.injectEndpoints({
  endpoints: (builder) => ({
    getClaimSubmissions: builder.query<any, any>({
      query: (arg) => ({
        url: "Claim/GetClaimSubmissionList",
        params: { ...arg },
      }),
      transformResponse: (response: any) => {
        if (response?.results && Array.isArray(response.results)) {
          return response;
        }

        return {
          results: [
            {
              submissionId: "SUBM-001",
              documentType: "PDF",
              creditorName: "John Creditor",
              debtorName: "Acme Debtor Ltd",
              submittedBy: "System",
              submittedOn: "2024-12-12",
              status: "Submitted",
              creditorId: "abc123",
              isActive: true,
              totalClaims: 1,
              creditorReference: "CREF-001",
            },
            {
              submissionId: "SUBM-002",
              documentType: "Excel",
              creditorName: "Jane Creditor",
              debtorName: "Gamma Inc.",
              submittedBy: "User A",
              submittedOn: "2024-12-10",
              status: "Pending",
              creditorId: "abc456",
              isActive: true,
              totalClaims: 0,
              creditorReference: "CREF-002",
            },
          ],
          hasMoreRecords: false,
        };
      },
    }),
    getClaimSubmissionDetails: builder.query<any, { caseId: string; submissionId: string }>({
        query: ({ caseId, submissionId }) => ({
          url: `Claim/GetClaimSubmissionDetails`,
          params: { caseId, submissionId },
        }),
        transformResponse: (_response: any, _meta, { submissionId }) => {
            
          const mockDetailsMap: Record<string, any> = {
            "SUBM-001": {
              creditor: {
                firstName: "Pete",
                lastName: "Samson",
                phone: "+1 555 111 2222",
                email: "pete.samson@acme.com",
                address1: "42 Wallaby Way",
                address2: "Suite 200",
                country: "USA",
                city: "Seattle",
                provinceState: "WA",
                postalCode: "98101",
                lastUpdatedOn: "2024-12-11",
                lastUpdatedBy: "Pete Samson",
              },
              assignee: {
                firstName: "Sara",
                lastName: "Connor",
                phone: "+1 555 333 4444",
                email: "sara.connor@acme.com",
                address1: "58 Terminator Lane",
                address2: "Floor 5",
                country: "USA",
                city: "Austin",
                provinceState: "TX",
                postalCode: "73301",
                lastUpdatedOn: "2024-12-10",
                lastUpdatedBy: "System",
              },
              documents: [
                {
                  fileName: "ClaimDetails_SUBM-001.xlsx",
                  uploadedOn: "2024-12-11",
                  uploadedBy: "Pete Samson",
                  fileType: "Excel",
                },
              ],
            },
            "SUBM-002": {
              creditor: {
                firstName: "Jane",
                lastName: "Doe",
                phone: "+1 555 666 7777",
                email: "jane.doe@beta.com",
                address1: "7 Beta Block",
                address2: "Flat 302",
                country: "USA",
                city: "San Francisco",
                provinceState: "CA",
                postalCode: "94103",
                lastUpdatedOn: "2024-12-09",
                lastUpdatedBy: "Jane Doe",
              },
              assignee: {
                firstName: "Mike",
                lastName: "Ross",
                phone: "+1 555 888 9999",
                email: "mike.ross@beta.com",
                address1: "23 Suits Street",
                address2: "Unit 12",
                country: "USA",
                city: "New York",
                provinceState: "NY",
                postalCode: "10001",
                lastUpdatedOn: "2024-12-08",
                lastUpdatedBy: "Admin",
              },
              documents: [
                {
                  fileName: "ClaimSummary_SUBM-002.xlsx",
                  uploadedOn: "2024-12-09",
                  uploadedBy: "Jane Doe",
                  fileType: "Excel",
                },
              ],
            },
          };
      
          return mockDetailsMap[submissionId] ?? {
            creditor: {},
            assignee: {},
            documents: [],
          };
        },
      }),
      
  }),
});

export const { useGetClaimSubmissionsQuery, useGetClaimSubmissionDetailsQuery } = ClaimSubmissionsApi;
